import { environment } from '../../../environments/environment';

export const API_BASE_URL = environment.baseUrl;
export const DEFAULT_CID = environment.cid;
export const RAZORPAY_KEY = environment.razorpayKey;
export const COMPANY_NAME = (environment as any).companyName || 'Amul Digital';
export const COMPANY = (environment as any).company || 'amuldigital';

export const API_ENDPOINTS = {
  // Public Storefront
  PRODUCT_DISPLAY_ZONE_ALL: (cid: number | string = DEFAULT_CID) => `${API_BASE_URL}productDisplayZone/all/${cid}`,
  PRODUCT_CATEGORY_ALL: (cid: number | string = DEFAULT_CID) => `${API_BASE_URL}productCategory/all/${cid}`,
  BANNER_ZONE_ALL: (cid: number | string = DEFAULT_CID) => `${API_BASE_URL}bannerZone/all/${cid}`,
  PRODUCT_CATEGORY_BY_ID: (id: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}productCategory/${id}/${cid}`,
  PRODUCT_BY_ID: (id: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}productMaster/${id}/${cid}`,
  PRODUCT_ALL: (cid: number | string = DEFAULT_CID) => `${API_BASE_URL}productMaster/allProductMasterByCid/${cid}`,
  PRODUCT_PAGINATION: (page: number = 0, size: number = 50, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}productMaster/all/${cid}/${page}/${size}`,

  // Auth
  LOGIN: `${API_BASE_URL}users/login`,
  USERS_BY_PHONE: (phone: string) => `${API_BASE_URL}users/getUsersByPhNo/${phone}`,
  REGISTER: `${API_BASE_URL}customerInfo`,

  // Cart & Wishlist
  ADD_TO_CART: (userId: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}myCart/addProductInMyCart/${userId}/${cid}`,
  GET_MY_CART: (userId: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}myCart/getByUserId/${userId}/${cid}`,
  REMOVE_CART_PRODUCT: (userId: number | string, productId: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}myCart/removeProduct/${userId}/${productId}/${cid}`,
  HARD_DELETE_CART: (cartId: number | string) => `${API_BASE_URL}myCart/hardDelete/${cartId}`,
  UPDATE_CART_QUANTITY: `${API_BASE_URL}myCart/updateProductQuantity`,
  MOVE_TO_WISHLIST: `${API_BASE_URL}myCart/moveProductToWishList`,

  ADD_TO_WISHLIST: (userId: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}wishList/addProductInWishList/${userId}/${cid}`,
  GET_MY_WISHLIST: (userId: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}wishList/getByUserId/${userId}/${cid}`,
  REMOVE_WISHLIST_PRODUCT: (userId: number | string, productId: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}wishList/removeProduct/${userId}/${productId}/${cid}`,
  MOVE_TO_CART: `${API_BASE_URL}wishList/moveProductToMyCart`,

  // Customer Profile & Address
  GET_CUSTOMER_BY_MOBILE: (mobile: string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}customerInfo/getByMobile/${mobile}/${cid}`,
  GET_CUSTOMER_BY_ID: (id: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}customerInfo/${id}/${cid}`,
  ADD_CUSTOMER_ADDRESS: `${API_BASE_URL}customerInfo/addCustomerInfoAddress`,
  UPDATE_CUSTOMER_ADDRESS: `${API_BASE_URL}customerInfo/updateCustomerAddress`,
  DELETE_CUSTOMER_ADDRESS: (customerInfoId: number | string, slNo: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}customerInfo/deleteCustomerAddress/${customerInfoId}/${slNo}/${cid}`,
  GET_GEO_ADDRESS: (customerInfoId: number | string, slNo: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}customerInfo/getGeoAddressByCustomerInfoIdAndSlNo/${customerInfoId}/${slNo}/${cid}`,

  // Orders & Invoicing & Tickets
  CUSTOMER_INVOICE: `${API_BASE_URL}customerInvoice`,
  GENERATE_ORDER_ID: (invoiceId: number | string, amount: number | string) => `${API_BASE_URL}razorPay/generatedOrderId/${invoiceId}/${amount}`,
  RAZORPAY_SUCCESS: `${API_BASE_URL}razorPay/success`,
  INSERT_ECOM_TICKET: `${API_BASE_URL}ticket/insertEComTicket`,
  GET_INVOICES_BY_PHONE: (phone: string) => `${API_BASE_URL}customerInvoice/getByUserPhone/${phone}`,
  GET_INVOICE_BY_ID: (invoiceId: number | string, cid: number | string = DEFAULT_CID) => `${API_BASE_URL}customerInvoice/${invoiceId}/${cid}`
};
